export default {
  参观商: '参观商',
  主办方: '主办方',
  主办商: '主办商',
  参展商: '企业',
  设计师: '设计师',
  工程商: '工程商',
  展厅工程商: '展厅工程商',
  服务商: '服务商',
  申请成为参展商: '申请成为参展商',
  申请成为主办方: '申请成为主办方',
  申请成为主办商: '申请成为主办商',
  申请成为设计师: '申请成为设计师',
  申请成为工程商: '申请成为工程商',
}
